import { Bonus, createDeleteBonusMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type DeleteBonusModel = ConfirmModalModel<Bonus, number, Bonus>;

export const createDeleteBonusModel = (): DeleteBonusModel => {
	const deleteBonusMutation = createDeleteBonusMutation();

	const model = createConfirmModalModel({
		modalData: declareModalData<Bonus>(),
		mapModalData: ({ id }) => id,
		mutation: deleteBonusMutation,
		successMessageKey: 'delete-bonus.success',
	});

	return model;
};
